import { render, staticRenderFns } from "./WorkDatesSetupView.vue?vue&type=template&id=d5bd4868&scoped=true&"
import script from "./WorkDatesSetupView.vue?vue&type=script&lang=ts&"
export * from "./WorkDatesSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bd4868",
  null
  
)

export default component.exports